export default __webpack_public_path__ + "static/media/Pot2.81222b1f.svg";